import { theme } from '@/analyses/_shared/theme';
import { TIER_CONFIG, type Tier } from '@/data/tiers';
import { COUNTRIES } from '@/data/countries';

export type StatsBarProps = {
  tierCounts: Record<Tier, number>;
};

const CARD_TIERS: Tier[] = [
  'easy',
  'moderate',
  'restricted',
  'blocked',
  'not-analyzed',
];

export const StatsBar = ({ tierCounts }: StatsBarProps) => {
  const total = COUNTRIES.length;
  const analyzed =
    tierCounts.easy +
    tierCounts.moderate +
    tierCounts.restricted +
    tierCounts.blocked;
  const pct = total > 0 ? Math.round((analyzed / total) * 100) : 0;

  return (
    <div
      style={{
        display: 'flex',
        gap: 10,
        alignItems: 'stretch',
        flexWrap: 'wrap',
      }}
    >
      {/* Coverage card — brand-accented */}
      <div
        style={{
          background: `linear-gradient(135deg, ${theme.BLUE}18 0%, ${theme.CARD} 70%)`,
          border: `1px solid ${theme.BLUE}55`,
          borderRadius: 10,
          padding: '8px 14px',
          minWidth: 132,
        }}
      >
        <div
          style={{
            color: theme.BLUE_SOFT,
            fontSize: 10,
            textTransform: 'uppercase',
            letterSpacing: 0.7,
            fontWeight: 700,
          }}
        >
          Coverage
        </div>
        <div
          style={{
            color: theme.WHITE,
            fontSize: 16,
            fontWeight: 800,
            marginTop: 2,
            letterSpacing: -0.2,
          }}
        >
          {analyzed}
          <span style={{ color: theme.MUTED, fontWeight: 500 }}>
            {' '}/ {total}
          </span>{' '}
          <span
            style={{
              color: theme.MUTED,
              fontSize: 12,
              fontWeight: 500,
            }}
          >
            ({pct}%)
          </span>
        </div>
      </div>

      {CARD_TIERS.map((tier) => {
        const cfg = TIER_CONFIG[tier];
        return (
          <div
            key={tier}
            style={{
              background: theme.CARD,
              border: `1px solid ${theme.BORDER}`,
              borderRadius: 10,
              padding: '8px 14px',
              minWidth: 108,
            }}
          >
            <div
              style={{
                color: theme.MUTED,
                fontSize: 10,
                textTransform: 'uppercase',
                letterSpacing: 0.7,
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  background: cfg.color,
                  display: 'inline-block',
                  boxShadow: `0 0 0 2px ${cfg.color}22`,
                }}
              />
              {cfg.label}
            </div>
            <div
              style={{
                color: cfg.color,
                fontSize: 18,
                fontWeight: 800,
                marginTop: 2,
                letterSpacing: -0.3,
              }}
            >
              {tierCounts[tier]}
            </div>
          </div>
        );
      })}
    </div>
  );
};
